<template>
    <div class="result">
        <div class="result-content">
              <div class="result-total">{{this.list.projectName}}{{this.list.announceType}}</div>
              <div style="text-align: center;margin-top: 10px;font-size: 18px;font-weight: 300;">发布时间: 2022-12-05 16:00:30</div>
              <div style="height: 1px; background-color: #F3F3F3 ;width: 100%;margin-top: 15px;"></div>
              <div class="result-statue">
                 <div class="result-content-item1">一, 项目基本情况</div>
                 <div class="result-content-item">采购项目编号: {{this.list.planCode}}</div>
                 <div class="result-content-item">采购项目名称: {{this.list.projectName}}{{this.list.announceType}}</div>
                 <div class="result-content-item">采购需求:</div>
                 <div class="result-content-item">
                     <div style="margin-top:20px">A</div>
                     <div style="margin-top:20px">
                        <Table :columns="columns"  border></Table>
                     </div>
                 </div>
                 <div class="result-content-item1">二, 申请人资质要求</div>

                 <div class="result-content-item1">三, 招标文件发售</div>
                 <div class="result-content-item">1.发售时间: {{this.list.flowSubmitTime.substring(0,10)}}~{{this.list.flowFinishTime.substring(0,10)}}</div>
                 <div class="result-content-item">2.发售地点: {{this.list.location}}</div>
                 <div class="result-content-item">3.文件售价: ￥{{this.list.price}}</div>

                 <div class="result-content-item1">四, 开标时间和地点</div>
                 <div class="result-content-item">1.发售时间: {{this.list.bidOpeningDate.substring(0,10)}}</div>
                 <div class="result-content-item">2.发售地点: {{this.list.bidOpeningLocation.substring(0,10)}}</div>

                 <div class="result-content-item1">五, 其他补充事宜</div>

                 <div class="result-content-item1">附件</div>
                 <div  v-for="(item,index) in dowmList" :key="index">
                    <div  style="margin-top: 20px;width: 600px;margin-bottom: 20px;height: 20px;">
                        <div style="float: left">{{item.fileName}}</div>
                        <div style="float: right" @click="handleUpload(item.id)">下载</div>
                    </div>
                 </div>

                 <div class="result-content-item1">六, 凡对本项目提出询问，请按一下联系方式联系</div>
                 <div class="result-content-item">1.采购人信息</div>

                 <Form :model="list" label-position="right" :label-width="100">
                        <FormItem label="名称:">
                            {{list.proUnit}}
                        </FormItem>
                        <FormItem label="地点:">
                            {{list.proLocation}}
                        </FormItem>
                        <FormItem label="联系人`:">
                            {{list.projectContact.name}}
                        </FormItem>
                        <FormItem label="电话:">
                            {{list.proContactUs}}
                        </FormItem>
                 </Form>
                 <div class="result-content-item">2.采购代理机构信息</div>
                 <Form :model="list" label-position="right" :label-width="100">
                        <FormItem label="名称:">
                            {{list.tenderAgencyName}}
                        </FormItem>
                        <FormItem label="地点:">
                            {{list.tenderAgencyLocation}}
                        </FormItem>
                        <FormItem label="联系人:">
                            {{list.tenderAgencyContact}}
                        </FormItem>
                        <FormItem label="电话:">
                            {{list.tenderAgencyContactUs}}
                        </FormItem>
                 </Form>
                 <div class="result-content-item1">相关附件</div>
              </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'result',
    data(){
        return{
            columns: [
                    {
                        title: '序号',
                        key: 'number',
                        resizable: true,
                        width: 180
                    },
                    {
                        title: '采购需求',
                        key: 'need',
                        resizable: true,
                        width: 280
                    },
                    {
                        title: '计量单位',
                        key: 'measure',
                        resizable: true,
                        width: 280
                    },
                    {
                        title: '是否接受进口产品',
                        key: 'import',
                        resizable: true,
                        width: 280
                    },
                    {
                        title: '预算金额(万元)(人民币)',
                        key: 'money',
                    }
                ],
                id:'',
                billdefine:'',
                address:'',
                list:{},
                dowmList:[]
        }
    },
    created(){
        GMS.vbus.$on('on-result-change',(res)=>{
            this.id = res.id
            this.address = res.ip
            this.billdefine = res.billdefine
            this.getResult()
        })
    },
    mounted(){},
    methods:{
        getResult() {
            GMS.$http.post('/portal/information', {
                 data: this.address +'/portal/announce/'+this.billdefine+'/'+this.id
            }).then(res => {
                if (res.status == 200) {
                    this.list = res.data.content
                    this.getDownload()
                }
            }).catch(error => {
                this.$Message.error("获取数据异常，请联系管理员");
            })
        },
        getDownload(){
           GMS.$http.post('/portal/information', {
                 data: this.address + '/portal/announce/attachment/owner/'+'6c0c6d80-d0e2-4da9-a2b3-be6a9c019698'
            }).then(res => {
                if (res.status == 200) {
                    this.dowmList = res.data.item

                }
            }).catch(error => {
                this.$Message.error("获取数据异常，请联系管理员");
            })
        },
        handleUpload(id) {
            GMS.$http.post('/portal/information', {
                 data: this.address + '/portal/announce/download/'+ id
                }
                // , {
                // responseType: 'blob',
                // }
                )
                .then((res) => {
                    console.log('rerrr',res)
                let blob = new Blob([res.data], {
                    type: 'multipart/form-data;charset=utf-8',
                })
                //对文件名乱码转义--【Node.js】使用iconv-lite解决中文乱码
                let iconv = require('iconv-lite')
                iconv.skipDecodeWarning = true //忽略警告
                let downloadElement = document.createElement('a')
                let href = window.URL.createObjectURL(blob) // 创建下载的链接
                downloadElement.href = href
                downloadElement.download = list.fileName // 下载后文件名
                document.body.appendChild(downloadElement)
                downloadElement.click() // 点击下载
                document.body.removeChild(downloadElement) // 下载完成移除元素
                window.URL.revokeObjectURL(href) // 释放掉blob对象
                })
            },
    }
}
</script>

<style lang="less" scoped>
.result{
    width: 100%;

    margin-top: 60px;
}
.result-content{
    margin: 0 auto;
    width: 1200px;
}
@media screen and (max-width:1500px){
    .result-content{
        width: 1200px;
    }
}
@media screen and (min-width:1500px) and (max-width:1800px){
    .result-content{
        width: 1400px;
    }
}
@media screen and (min-width:1800px){
    .result-content{
        width: 1600px;
    }
}
.result-total{
    text-align: center;
    font-size: 28px;
    font-weight: 400;
}
.result-statue{
   margin-left: 160px;
}
.result-content-item{
    margin-left: 30px;
}
.result-content-item1{
   font-size: 20px;
   font-weight: 400;
   margin-top: 20px;
}
.ivu-form-item{
    margin-bottom: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/inside/result.vue